import { Link } from "react-router-dom";
import { txt } from "../../../services/translation";

export default function Contact(){
    return (
        <div className="apply-contact">

            <span>
                {txt('needHelp')}
            </span>

            <span>
                <a href="tel:+33554547771">05 54 54 77 71</a>
                <span>&ensp;&bull;&ensp;</span>
                <Link to="/faq">FAQ</Link>
                <span>&ensp;&bull;&ensp;</span>
                <a href="https://www.learnylib.com/legal/accessibilites">{txt('accessibility')}</a>
            </span>
                
        </div>
    );
}